import {isPlayerPolicy} from "../factions/isPlayerPolicy";
import {POLICIES} from "../../constants/policies";
import {POLICY_PATRIOTISM_UNIT_SIZE_DISCOUNT} from "../../configs/policy/patriotism";

export const getSizeRecruitmentPrice = (unitConfig, player) => {
  let upgradePrice = unitConfig.sizePrice;
  const originalPrice = upgradePrice;

  if (isPlayerPolicy(player, POLICIES.PATRIOTISM)) {
    upgradePrice -= POLICY_PATRIOTISM_UNIT_SIZE_DISCOUNT;
  }

  return {
    sizePrice: upgradePrice,
    isDiscount: originalPrice > upgradePrice,
  }
}